import { render, staticRenderFns } from "./SummitHome.vue?vue&type=template&id=81478abe&scoped=true"
import script from "./SummitHome.vue?vue&type=script&lang=js"
export * from "./SummitHome.vue?vue&type=script&lang=js"
import style0 from "./SummitHome.vue?vue&type=style&index=0&id=81478abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81478abe",
  null
  
)

export default component.exports